class AveyMobileNavigation extends HTMLElement {
  connectedCallback() {
    if (this.dataset.initialized === 'true') return;
    this.dataset.initialized = 'true';
    this.frame = null;
    this.topButton = this.querySelector('[data-mobile-navigation-top]');
    this.topButton?.addEventListener('click', this.scrollToTop);
    window.addEventListener('scroll', this.schedule, { passive: true });
    window.addEventListener('resize', this.schedule, { passive: true });
    window.addEventListener('avey:sticky-purchase:visibility', this.onStickyPurchaseVisibility);
    document.addEventListener('avey:overlay:open', this.hideForOverlay);
    document.addEventListener('avey:overlay:close', this.schedule);
    this.schedule();
  }

  disconnectedCallback() {
    this.topButton?.removeEventListener('click', this.scrollToTop);
    window.removeEventListener('scroll', this.schedule);
    window.removeEventListener('resize', this.schedule);
    window.removeEventListener('avey:sticky-purchase:visibility', this.onStickyPurchaseVisibility);
    document.removeEventListener('avey:overlay:open', this.hideForOverlay);
    document.removeEventListener('avey:overlay:close', this.schedule);
    if (this.frame) cancelAnimationFrame(this.frame);
  }

  scrollToTop() {
    window.scrollTo({ top: 0, behavior: 'smooth' });
  }
  hideForOverlay = () => this.setVisible(false);

  onStickyPurchaseVisibility = (event) => {
    const stickyHeight = event.detail?.visible ? Number(event.detail?.height || 0) : 0;
    this.style.setProperty('--avey-mobile-navigation-bottom', `${Math.max(14, stickyHeight + 10)}px`);
    this.schedule();
  };

  schedule = () => {
    if (this.frame) return;
    this.frame = requestAnimationFrame(() => {
      this.frame = null;
      const currentY = window.scrollY;
      const mobile = window.matchMedia('(max-width: 767px)').matches;
      const overlayOpen = document.documentElement.dataset.aveyOverlayState === 'open';
      const details = document.querySelector('.avey-product-tabs');
      const detailsBar = details?.querySelector('.avey-product-tabs__bar');
      const detailsStickyTop = Number.parseFloat(detailsBar ? getComputedStyle(detailsBar).top : '') || 0;
      const detailsReached = detailsBar
        ? detailsBar.getBoundingClientRect().top <= detailsStickyTop + 1
        : currentY > Math.max(420, window.innerHeight * 0.72);
      const stickyPurchase = document.querySelector('.avey-sticky-purchase.is-visible');
      const stickyHeight = stickyPurchase?.getBoundingClientRect().height || 0;
      this.style.setProperty('--avey-mobile-navigation-bottom', `${Math.max(14, stickyHeight + 10)}px`);
      this.setVisible(mobile && detailsReached && !overlayOpen);
    });
  };

  setVisible(visible) {
    this.classList.toggle('is-visible', visible);
    this.toggleAttribute('inert', !visible);
    this.setAttribute('aria-hidden', String(!visible));
  }
}

if (!customElements.get('avey-mobile-navigation')) {
  customElements.define('avey-mobile-navigation', AveyMobileNavigation);
}
